
<script>

    import IconMap from "@/components/icons/IconMap";
    import MediaWatcher from "@/modules/common/MediaWatcher";
    import ModalsContainer from "./components/modals/ModalsContainer";

    export default {

        name: "app",

        components: {
            ModalsContainer,
            MediaWatcher,
            IconMap,
        },

    }

</script>

<template>
  <div id="ot-app" class="ot-app">
      <icon-map/>
      <media-watcher/>
      <modals-container/>
      <transition name="fade" mode="out-in">
          <router-view></router-view>
      </transition>
  </div>
</template>

<style lang="less">
    @import (reference) "./theme/minimum.less";
    @import "./theme/layouts.less";
    @import "./theme/forms.less";
    @import "./theme/transitions.less";
    @import "./theme/typography.less";

    *, *:before, *:after {
        box-sizing: border-box;
    }
    html, body {
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    html {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -ms-text-size-adjust: 100%; // 2
        -webkit-text-size-adjust: 100%; // 2
        font-size: @font-size-base;
        min-width: 500px;
        min-height: 500px;
    }
    body {
        font-family: 'Lato', 'FallbackFamily', sans-serif;
        color: @color-text-base;
        margin: 0;
        font-weight: @font-weight-base;
        min-width: 500px;
        min-height: 500px;
    }
    .ot-app {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        min-width: 500px;
        min-height: 500px;
    }
</style>
